import { render, staticRenderFns } from "./Reviewrecords.vue?vue&type=template&id=6d2a453e&scoped=true"
import script from "./Reviewrecords.vue?vue&type=script&lang=js"
export * from "./Reviewrecords.vue?vue&type=script&lang=js"
import style0 from "./Reviewrecords.vue?vue&type=style&index=0&id=6d2a453e&prod&lang=css"
import style1 from "./Reviewrecords.vue?vue&type=style&index=1&id=6d2a453e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a453e",
  null
  
)

export default component.exports